<template>
  <div class="account-outer">
    <div class="account-inner">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.account-outer {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
  position: relative;
  background-color: $color-black;
}

.account-inner {
  width: 90%;

  @include tablet {
    width: 50%;
  }
}
</style>
